import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DomSanitizer } from "@angular/platform-browser";

@Component({
    selector: 'app-text-tooltip-right-renderer',
    templateUrl: './text-tooltip-right-renderer.component.html',
    standalone: false
})
export class TextWithTooltipRightRendererComponent implements ICellRendererAngularComp {
    text: string;
    toolTipText: string;
    constructor(private sanitizer: DomSanitizer) {

    }

    initilize(params: ICellRendererParams) {
        if (params.data) {
            this.text = params.getValue();
            this.toolTipText = params.data.tooltip;
        }
    }

    // called on init
    agInit(params: any): void {
        this.initilize(params);

    }

    // called when the cell is refreshed
    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

    sanitizerHtml(element) {
      return this.sanitizer.bypassSecurityTrustHtml(element);
    }

}
